export default __webpack_public_path__ + "static/media/Beckett_Industries_LE.610e5d97.jpg";